import FpuiIcon from './FpuiIcon'

export { FpuiIcon }
export default { FpuiIcon }
